import React from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./conta-verificada.css";

function ContaVerificada() {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <div className="verify-container">
        <h2>✅ Conta verificada com sucesso!</h2>
        <p>
          Seu e-mail foi confirmado. Agora você pode prosseguir para o pagamento
          e ativar sua assinatura.
        </p>
        <button
          className="auth-button"
          onClick={() => navigate("/pagamento")}
        >p
          Ir para pagamento
        </button>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default ContaVerificada;
